import dayjs from "dayjs";
import { Feature, Overlay } from "ol";
import WebGLPointsLayer from "ol/layer/WebGLPoints";
import { Cluster } from "ol/source";
import VectorSource from "ol/source/Vector";


let intervalId;

export const circleTimeMap = ({ map, featureCollection, activeLayers, setActiveLayers }) => {
    const minDateInput = document.getElementById("minDateInput");
    const maxDateInput = document.getElementById("maxDateInput");
    const currentDateInput = document.getElementById("currentDateInput");

    const intervalStartButton = document.getElementById("intervalStartButton");
    const intervalStopButton = document.getElementById("intervalStopButton");
    const intervalResetButton = document.getElementById("intervalResetButton");

    const currentDateValue = document.getElementById("currentDate");

    const clusterSizeValue = document.getElementById("clusterSize");


    let overlay;
    let date;
    

    let layer;
    let source;

    let minDate;
    let maxDate;

    let selected = null;

    const hoverEvent = (e) => {
        if(selected !== null) {
            selected.set('hover', 0);
            selected = null;
            clusterSizeValue.textContent = null;
        }

        map.forEachFeatureAtPixel(e.pixel, (feature) => {
            feature.set('hover', 1);
            selected = feature;
            clusterSizeValue.textContent = feature.get("size");

            return true;
        });
    };

    const styleVariables = {
        currentDate: dayjs("2000-01-01").unix()
    }


    const onChangeMinDateHandle = () => {
        const minDateValue = document.getElementById("minDate").innerText;
        minDate = dayjs(minDateValue);
        if(date < minDate) {
            date = minDate;
        }
    }

    const onChangeMaxDateHandle = () => {
        const maxDateValue = document.getElementById("maxDate").innerText;
        maxDate = dayjs(maxDateValue);
    }


    const updateDate = () => {
        if (date.isAfter(maxDate)) {
            clearInterval(intervalId);
        } else {
            overlay.getElement().textContent = date.format("YYYY-MM");
            currentDateInput.value = date.diff(minDate, 'month');
            currentDateValue.textContent = date.format("YYYY-MM");
            styleVariables.currentDate = date.unix();

            source.clear();

            const features = [];
                            
            featureCollection.forEach((data) => {
                data.featureArray.forEach((feature, idx) => {
                    const clonedFeature = feature.clone();

                    const terminationDate = dayjs(feature.get("termination_date")).set('date', 1).unix();

                    clonedFeature.set("terminationDate", terminationDate);
                    
                    if(terminationDate === date.unix()) {
                        features.push(clonedFeature);
                    }
                })
            });

            source.addFeatures(features);
            
            map.render();
            date = date.add(1, "M");
        }
    };

    const renderDate = () => {
        if(source.getFeatures().length > 0) {
            onChangeMinDateHandle();
            onChangeMaxDateHandle();
    
            if(!date) {
                date = minDate;
            }
    
            if(intervalId) {
                clearInterval(intervalId);
            }
    
            intervalId = setInterval(updateDate, 3000);
        }
    }

    const stopInterval = () => {
        clearInterval(intervalId)
    }

    const resetDate = () => {
        onChangeMinDateHandle();
        date = minDate;
        updateDate();
        stopInterval();
    }

    const inputDate = () => {
        onChangeMinDateHandle();
        onChangeMaxDateHandle();
        stopInterval();
        date = dayjs(currentDateValue.innerText).set("date", 1);
        updateDate();
    }

    const mount = () => {
        if(activeLayers) {
            setActiveLayers();
        }

        source = new VectorSource({});

        date = dayjs(currentDateValue.innerText).set("date", 1);

        const cluster = new Cluster({
            source: source,
            distance: 40,
            minDistance: 20,
            createCluster: (point, features) => {
                const cluster = new Feature({
                    geometry: point,
                    features: features,
                })

                cluster.set("size", features.length);

                return cluster;
            }
        })        

        const style = {
            variables: styleVariables,
            'circle-radius': [
                'interpolate',
                ['exponential', 2],
                ['zoom'],
                5,
                ['*', 0.01, ['get', 'size']],
                15,
                ['*', 0.01, ['get', 'size'], Math.pow(2, 10)],
            ],
            'circle-stroke-width': 1,
            'circle-stroke-color': "#fff",
            'circle-opacity': 0.5,
            'circle-fill-color': ['match', ['get', 'hover'], 1, "#ff7f00", "#ff0000"]            
        };
        
        layer = new WebGLPointsLayer({
            source: cluster,
            zIndex: 20,
            style: style
        })

        setActiveLayers([layer]);

        overlay = new Overlay({
            element: document.createElement('div'),
        });

        overlay.set("title", "pointTime")

        const overlayParent = overlay.getElement().parentElement;
        overlayParent.style.display = 'flex';
        overlayParent.style.position = 'absolute';
        overlayParent.style.bottom = '30px';
        overlayParent.style.left = '30px';
        overlayParent.style.fontSize = '18px';
        overlayParent.style.fontWeight = 'bold';

        map.addOverlay(overlay);

        minDateInput.addEventListener('change', onChangeMinDateHandle);
        maxDateInput.addEventListener('change', onChangeMaxDateHandle);
        intervalStartButton.addEventListener('click', renderDate);
        intervalStopButton.addEventListener('click', stopInterval);
        intervalResetButton.addEventListener('click', resetDate);
        currentDateInput.addEventListener('change', inputDate);

        map.on('pointermove', hoverEvent);

        updateDate();

        return {
            onChangeMinDateHandle: onChangeMinDateHandle,
            onChangeMaxDateHandle: onChangeMaxDateHandle,
            renderDate: renderDate,
            stopInterval: stopInterval,
            resetDate: resetDate,
            inputDate: inputDate,
            hoverEvent: hoverEvent
        };
    };

    const dismount = (fn) => {
        const overlays = map.getOverlays().getArray();
        const pointTimeOverlay = overlays.filter((overlay) => overlay.get("title") === "pointTime");

        if(minDateInput) {
            minDateInput.removeEventListener('change', fn.onChangeMinDateHandle);
        }
        if(maxDateInput) {
            maxDateInput.removeEventListener('change', fn.onChangeMaxDateHandle);
        }
        if(intervalStartButton) {
            intervalStartButton.removeEventListener('click', fn.renderDate);
        }
        if(intervalStopButton) {
            intervalStopButton.removeEventListener('click', fn.MathstopInterval);
        }
        if(intervalResetButton) {
            intervalResetButton.removeEventListener('click', fn.resetDate);
        }
        if(currentDateInput) {
            currentDateInput.removeEventListener('change', fn.inputDate);
        }

        map.un('pointermove', fn.hoverEvent);

        pointTimeOverlay.forEach((overlay) => {
            map.removeOverlay(overlay);
        })

        clearInterval(intervalId)
        setActiveLayers();
        map.render();
    };

    return { mount: mount, dismount: dismount };
}
